<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <app-sub-header title="Add Photo Gallery"></app-sub-header>

                <div *ngIf=" photoarr.length < 6" class="btn btn-block main-backgroundcolor color">
                    Add {{dummyError.length != 0 ? dummyError.length : ''}} photos to your gallery </div>

                <div *ngIf=" photoarr.length == 6" class="btn btn-block main-backgroundcolor color">
                    Business photos added to your gallery.
                </div>
                <div style="min-height: 500px;">
                    <div class="display">

                        <div class="form-group register-input" *ngFor="let props of arr; let i = index">

                            <label *ngIf="!props.show" class="btn-bs-file btn btn-lg ">

                                <div *ngIf="!arr[i].showLoader"> <i class="fas fa-plus position"></i> </div>
                                <div *ngIf="arr[i].showLoader" class="spinner-border text-muted"
                                    style="position: absolute; top:40%; left:40%;"></div>
                                <input type="file" (change)="uploadImage($event,i)" />
                            </label>
                            <div class="profile-image" *ngIf="props.show" style="position: relative;">
                                <div class="position-2 cursor" *ngIf="props.show" (click)="deleteImage(i)"> <i
                                        class="fas fa-times-circle"></i></div>
                                <div *ngIf="arr[i].deleteImage" class="spinner-border text-muted"
                                    style="position: absolute; top:40%; left:40%;"></div>

                                <div class="image-wrapper" style=" width: 150px; height: 150px;">
                                    <img [src]="renderImage(photoarr[i])" alt="Profile-Pic" width="150" height="150"
                                        style="object-fit: cover;">
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div class="btn btn-block main-backgroundcolor color" (click)="onSubmit()">
                    Save </div>
            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>